import moment from 'moment';

import {EventApiWithWorkLogProps, EventAssignmentSummary} from '../types';

const hasOverlappingEvents = (events: EventApiWithWorkLogProps[]): boolean => {
  events.sort((a, b) => a.start!.getTime() - b.start!.getTime());

  return events.some((currEvent, i) => {
    const prevEvent = events[i - 1];
    return prevEvent != null && currEvent.start! < prevEvent.end!;
  });
};

export const useEventAssignmentSummary = (
  allEvents: EventApiWithWorkLogProps[],
  selectedDay: moment.Moment
): {
  eventSummary: EventAssignmentSummary;
} => {
  const eventsOnDay = allEvents.filter((e) =>
    selectedDay.isSame(e.start, 'day')
  );

  const unassignedEvents = eventsOnDay.filter(
    (e) => e.extendedProps.activity === undefined
  );

  const eventsWithActivity = eventsOnDay.filter(
    (e) => e.extendedProps.activity !== undefined
  );

  const casusEvents = eventsWithActivity.filter(
    (e) => e.extendedProps.activity!.casusId
  );

  const internalEvents = eventsWithActivity.filter(
    (e) => e.extendedProps.activity!.internalHoursCategoryId
  );

  return {
    eventSummary: {
      casus: casusEvents,
      internal: internalEvents,
      unassigned: unassignedEvents,
      hasOverlap: hasOverlappingEvents(eventsOnDay),
    },
  };
};
